import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import useFundedAccount from '@/hooks/use-funded-account';
import { useIsMigrated } from '@/hooks/use-migration';

interface FundedAccountGuardProps {
  children: React.ReactNode;
}

export const FundedAccountGuard = ({ children }: FundedAccountGuardProps) => {
  const { isFundedOrEval } = useFundedAccount();
  const isMigrated = useIsMigrated();

  if (isFundedOrEval) {
    return (
      <Navigate to={isMigrated ? ROUTES.MIGRATION : ROUTES.PORTFOLIO} replace />
    );
  }

  return <>{children}</>;
};
